/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import TapTop from "./TapTop";
import { useAppDispatch, useAppSelector } from "../reduxToolkit/hooks";
import { addSidebarTypes, setSideBarToggle } from "../reduxToolkit/reducers/layout/themeCustomizerSlice";
import Header from "./header";
import Sidebar from "./sidebar";
import ThemeCustomizer from "./themeCustomizer";
import AlarmCheck from "../components/configuration/Alarms/CheckAlarm";

const Layout = () => {
  const { sidebarTypes, sideBarToggle } = useAppSelector((state) => state.themeCustomizer);
  const dispatch = useAppDispatch();

  // function for sidebar type change from vertical to horizontal
  const updateSidebarBasedOnWidth = () => {
    const windowWidth = window.innerWidth;
    if (sidebarTypes === "compact-wrapper") {
      if (windowWidth <= 1200) dispatch(setSideBarToggle(true));
      else dispatch(setSideBarToggle(false));
    } else if (sidebarTypes === "horizontal-wrapper") {
      if (windowWidth <= 992) {
        dispatch(setSideBarToggle(true));
        dispatch(addSidebarTypes("compact-wrapper"));
      } else {
        dispatch(setSideBarToggle(false));
        dispatch(addSidebarTypes("horizontal-wrapper"));
      }
    }
  };
  useEffect(() => {
    updateSidebarBasedOnWidth();
    window.addEventListener("resize", () => updateSidebarBasedOnWidth());
  }, [sidebarTypes]);
  
  return (
    <>
      <TapTop />
      <div className={`page-wrapper ${sideBarToggle ? "compact-wrapper" : sidebarTypes}`}>
        <Header />
        <AlarmCheck/>
        <div className="page-body-wrapper">
          <Sidebar />
          <div className="page-body">
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
      <ThemeCustomizer />
    </>
  );
};

export default Layout;